import { BaseModel } from './_Index';
import {TipoGestionale} from './generated/tipo-gestionale';

export class Organizzazione extends BaseModel {
  codiceGruppo: string;
  tipoInstallazione: number;
  tipoGestionale?: TipoGestionale;
  pathFile: string;
  indirizzoApiEsolver?: string;
  indirizzoApiBilance?: string;
  indirizzoApiStorage?: string;
  pathStorage?: string;
  hostFtp: string;
  utenteFtp: string;
  passwordFtp: string;
  hostApiEsolver: string;
  usernameApiEsolver: string;
  passwordApiEsolver: string;
  codCliForEsolver?: number;
  boxFormatoTerz?: number;
  boxFormatoInve?: number;
  boxFormatoDdt?: number;
  boxFormatoOdS?: number;
  boxFormatoOdP?: number;
  controlliQualitaTipoInizio?: number;
  controlliQualitaTipoFine?: number;
  controlliQualitaTipoMerce?: number;
  tipoTracciatoAvp?: number;
  esitoAvpMode?: number;
  separaAvp?: string;
  timeZoneOfDate?: string;
  avpAttivoDa?: string;
  avpAttivoA?: string;
  logoUrl?: string;
  enableLoginEvents?: boolean;
  enableLaunchOrdiniSpedizione?: boolean;
}
